/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as VideoPlayerRouteRouteImport } from './routes/_videoPlayer/route'
import { Route as UnauthenticatedRouteRouteImport } from './routes/_unauthenticated/route'
import { Route as ExternalRouteRouteImport } from './routes/_external/route'
import { Route as DefaultRouteRouteImport } from './routes/_default/route'
import { Route as DefaultIndexRouteImport } from './routes/_default/index'
import { Route as VideoPlayerSeriesDetailsRouteImport } from './routes/_videoPlayer/series-details'
import { Route as ExternalGetAppRouteImport } from './routes/_external/get-app'
import { Route as DefaultWinbackRouteImport } from './routes/_default/winback'
import { Route as DefaultTermsRouteImport } from './routes/_default/terms'
import { Route as DefaultShopRouteImport } from './routes/_default/shop'
import { Route as DefaultRewardsTabRouteImport } from './routes/_default/rewards-tab'
import { Route as DefaultRetentionRouteImport } from './routes/_default/retention'
import { Route as DefaultRefundRouteImport } from './routes/_default/refund'
import { Route as DefaultProfileRouteImport } from './routes/_default/profile'
import { Route as DefaultPrivacyRouteImport } from './routes/_default/privacy'
import { Route as DefaultMyListRouteImport } from './routes/_default/my-list'
import { Route as DefaultMoneyBackPolicyRouteImport } from './routes/_default/money-back-policy'
import { Route as DefaultFaqRouteImport } from './routes/_default/faq'
import { Route as DefaultDunningRouteImport } from './routes/_default/dunning'
import { Route as DefaultContactUsRouteImport } from './routes/_default/contact-us'
import { Route as DefaultCatalogRouteImport } from './routes/_default/catalog'
import { Route as VideoPlayerSeriesIndexRouteImport } from './routes/_videoPlayer/$series/index'
import { Route as DefaultSeriesIndexRouteImport } from './routes/_default/series/index'
import { Route as VideoPlayerSeriesPlayerIdRouteImport } from './routes/_videoPlayer/seriesPlayer.$id'
import { Route as VideoPlayerSeriesPlayerChar123IdChar125RouteImport } from './routes/_videoPlayer/series-player.{-$id}'
import { Route as VideoPlayerSeriesEpisodeRouteImport } from './routes/_videoPlayer/$series/$episode'
import { Route as UnauthenticatedAuthRecoverRouteImport } from './routes/_unauthenticated/auth/recover'
import { Route as UnauthenticatedAuthLinkRouteImport } from './routes/_unauthenticated/auth/link'
import { Route as DefaultThemesThemeRouteImport } from './routes/_default/themes/$theme'
import { Route as DefaultCategoriesCategoryRouteImport } from './routes/_default/categories/$category'
import { Route as DefaultActorsActorRouteImport } from './routes/_default/actors/$actor'
import { Route as DefaultSeriesSeriesRouteRouteImport } from './routes/_default/series/$series/route'
import { Route as DefaultSeriesSeriesIndexRouteImport } from './routes/_default/series/$series/index'
import { Route as DefaultSeriesSeriesRecommendationsRouteImport } from './routes/_default/series/$series/recommendations'
import { Route as DefaultSeriesSeriesEpisodesRouteImport } from './routes/_default/series/$series/episodes'
import { Route as DefaultSeriesSeriesCastRouteImport } from './routes/_default/series/$series/cast'
import { Route as DefaultSeriesSeriesBehindTheScenesRouteImport } from './routes/_default/series/$series/behind-the-scenes'

const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoPlayerRouteRoute = VideoPlayerRouteRouteImport.update({
  id: '/_videoPlayer',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRouteRoute = UnauthenticatedRouteRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalRouteRoute = ExternalRouteRouteImport.update({
  id: '/_external',
  getParentRoute: () => rootRouteImport,
} as any)
const DefaultRouteRoute = DefaultRouteRouteImport.update({
  id: '/_default',
  getParentRoute: () => rootRouteImport,
} as any)
const DefaultIndexRoute = DefaultIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const VideoPlayerSeriesDetailsRoute =
  VideoPlayerSeriesDetailsRouteImport.update({
    id: '/series-details',
    path: '/series-details',
    getParentRoute: () => VideoPlayerRouteRoute,
  } as any)
const ExternalGetAppRoute = ExternalGetAppRouteImport.update({
  id: '/get-app',
  path: '/get-app',
  getParentRoute: () => ExternalRouteRoute,
} as any)
const DefaultWinbackRoute = DefaultWinbackRouteImport.update({
  id: '/winback',
  path: '/winback',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultTermsRoute = DefaultTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultShopRoute = DefaultShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultRewardsTabRoute = DefaultRewardsTabRouteImport.update({
  id: '/rewards-tab',
  path: '/rewards-tab',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultRetentionRoute = DefaultRetentionRouteImport.update({
  id: '/retention',
  path: '/retention',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultRefundRoute = DefaultRefundRouteImport.update({
  id: '/refund',
  path: '/refund',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultProfileRoute = DefaultProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultPrivacyRoute = DefaultPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultMyListRoute = DefaultMyListRouteImport.update({
  id: '/my-list',
  path: '/my-list',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultMoneyBackPolicyRoute = DefaultMoneyBackPolicyRouteImport.update({
  id: '/money-back-policy',
  path: '/money-back-policy',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultFaqRoute = DefaultFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultDunningRoute = DefaultDunningRouteImport.update({
  id: '/dunning',
  path: '/dunning',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultContactUsRoute = DefaultContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultCatalogRoute = DefaultCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const VideoPlayerSeriesIndexRoute = VideoPlayerSeriesIndexRouteImport.update({
  id: '/$series/',
  path: '/$series/',
  getParentRoute: () => VideoPlayerRouteRoute,
} as any)
const DefaultSeriesIndexRoute = DefaultSeriesIndexRouteImport.update({
  id: '/series/',
  path: '/series/',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const VideoPlayerSeriesPlayerIdRoute =
  VideoPlayerSeriesPlayerIdRouteImport.update({
    id: '/seriesPlayer/$id',
    path: '/seriesPlayer/$id',
    getParentRoute: () => VideoPlayerRouteRoute,
  } as any)
const VideoPlayerSeriesPlayerChar123IdChar125Route =
  VideoPlayerSeriesPlayerChar123IdChar125RouteImport.update({
    id: '/series-player/{-$id}',
    path: '/series-player/{-$id}',
    getParentRoute: () => VideoPlayerRouteRoute,
  } as any)
const VideoPlayerSeriesEpisodeRoute =
  VideoPlayerSeriesEpisodeRouteImport.update({
    id: '/$series/$episode',
    path: '/$series/$episode',
    getParentRoute: () => VideoPlayerRouteRoute,
  } as any)
const UnauthenticatedAuthRecoverRoute =
  UnauthenticatedAuthRecoverRouteImport.update({
    id: '/auth/recover',
    path: '/auth/recover',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const UnauthenticatedAuthLinkRoute = UnauthenticatedAuthLinkRouteImport.update({
  id: '/auth/link',
  path: '/auth/link',
  getParentRoute: () => UnauthenticatedRouteRoute,
} as any)
const DefaultThemesThemeRoute = DefaultThemesThemeRouteImport.update({
  id: '/themes/$theme',
  path: '/themes/$theme',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultCategoriesCategoryRoute =
  DefaultCategoriesCategoryRouteImport.update({
    id: '/categories/$category',
    path: '/categories/$category',
    getParentRoute: () => DefaultRouteRoute,
  } as any)
const DefaultActorsActorRoute = DefaultActorsActorRouteImport.update({
  id: '/actors/$actor',
  path: '/actors/$actor',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const DefaultSeriesSeriesRouteRoute =
  DefaultSeriesSeriesRouteRouteImport.update({
    id: '/series/$series',
    path: '/series/$series',
    getParentRoute: () => DefaultRouteRoute,
  } as any)
const DefaultSeriesSeriesIndexRoute =
  DefaultSeriesSeriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DefaultSeriesSeriesRouteRoute,
  } as any)
const DefaultSeriesSeriesRecommendationsRoute =
  DefaultSeriesSeriesRecommendationsRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => DefaultSeriesSeriesRouteRoute,
  } as any)
const DefaultSeriesSeriesEpisodesRoute =
  DefaultSeriesSeriesEpisodesRouteImport.update({
    id: '/episodes',
    path: '/episodes',
    getParentRoute: () => DefaultSeriesSeriesRouteRoute,
  } as any)
const DefaultSeriesSeriesCastRoute = DefaultSeriesSeriesCastRouteImport.update({
  id: '/cast',
  path: '/cast',
  getParentRoute: () => DefaultSeriesSeriesRouteRoute,
} as any)
const DefaultSeriesSeriesBehindTheScenesRoute =
  DefaultSeriesSeriesBehindTheScenesRouteImport.update({
    id: '/behind-the-scenes',
    path: '/behind-the-scenes',
    getParentRoute: () => DefaultSeriesSeriesRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof DefaultIndexRoute
  '/download': typeof DownloadRoute
  '/catalog': typeof DefaultCatalogRoute
  '/contact-us': typeof DefaultContactUsRoute
  '/dunning': typeof DefaultDunningRoute
  '/faq': typeof DefaultFaqRoute
  '/money-back-policy': typeof DefaultMoneyBackPolicyRoute
  '/my-list': typeof DefaultMyListRoute
  '/privacy': typeof DefaultPrivacyRoute
  '/profile': typeof DefaultProfileRoute
  '/refund': typeof DefaultRefundRoute
  '/retention': typeof DefaultRetentionRoute
  '/rewards-tab': typeof DefaultRewardsTabRoute
  '/shop': typeof DefaultShopRoute
  '/terms': typeof DefaultTermsRoute
  '/winback': typeof DefaultWinbackRoute
  '/get-app': typeof ExternalGetAppRoute
  '/series-details': typeof VideoPlayerSeriesDetailsRoute
  '/series/$series': typeof DefaultSeriesSeriesRouteRouteWithChildren
  '/actors/$actor': typeof DefaultActorsActorRoute
  '/categories/$category': typeof DefaultCategoriesCategoryRoute
  '/themes/$theme': typeof DefaultThemesThemeRoute
  '/auth/link': typeof UnauthenticatedAuthLinkRoute
  '/auth/recover': typeof UnauthenticatedAuthRecoverRoute
  '/$series/$episode': typeof VideoPlayerSeriesEpisodeRoute
  '/series-player/{-$id}': typeof VideoPlayerSeriesPlayerChar123IdChar125Route
  '/seriesPlayer/$id': typeof VideoPlayerSeriesPlayerIdRoute
  '/series/': typeof DefaultSeriesIndexRoute
  '/$series/': typeof VideoPlayerSeriesIndexRoute
  '/series/$series/behind-the-scenes': typeof DefaultSeriesSeriesBehindTheScenesRoute
  '/series/$series/cast': typeof DefaultSeriesSeriesCastRoute
  '/series/$series/episodes': typeof DefaultSeriesSeriesEpisodesRoute
  '/series/$series/recommendations': typeof DefaultSeriesSeriesRecommendationsRoute
  '/series/$series/': typeof DefaultSeriesSeriesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof DefaultIndexRoute
  '/download': typeof DownloadRoute
  '/catalog': typeof DefaultCatalogRoute
  '/contact-us': typeof DefaultContactUsRoute
  '/dunning': typeof DefaultDunningRoute
  '/faq': typeof DefaultFaqRoute
  '/money-back-policy': typeof DefaultMoneyBackPolicyRoute
  '/my-list': typeof DefaultMyListRoute
  '/privacy': typeof DefaultPrivacyRoute
  '/profile': typeof DefaultProfileRoute
  '/refund': typeof DefaultRefundRoute
  '/retention': typeof DefaultRetentionRoute
  '/rewards-tab': typeof DefaultRewardsTabRoute
  '/shop': typeof DefaultShopRoute
  '/terms': typeof DefaultTermsRoute
  '/winback': typeof DefaultWinbackRoute
  '/get-app': typeof ExternalGetAppRoute
  '/series-details': typeof VideoPlayerSeriesDetailsRoute
  '/actors/$actor': typeof DefaultActorsActorRoute
  '/categories/$category': typeof DefaultCategoriesCategoryRoute
  '/themes/$theme': typeof DefaultThemesThemeRoute
  '/auth/link': typeof UnauthenticatedAuthLinkRoute
  '/auth/recover': typeof UnauthenticatedAuthRecoverRoute
  '/$series/$episode': typeof VideoPlayerSeriesEpisodeRoute
  '/series-player/{-$id}': typeof VideoPlayerSeriesPlayerChar123IdChar125Route
  '/seriesPlayer/$id': typeof VideoPlayerSeriesPlayerIdRoute
  '/series': typeof DefaultSeriesIndexRoute
  '/$series': typeof VideoPlayerSeriesIndexRoute
  '/series/$series/behind-the-scenes': typeof DefaultSeriesSeriesBehindTheScenesRoute
  '/series/$series/cast': typeof DefaultSeriesSeriesCastRoute
  '/series/$series/episodes': typeof DefaultSeriesSeriesEpisodesRoute
  '/series/$series/recommendations': typeof DefaultSeriesSeriesRecommendationsRoute
  '/series/$series': typeof DefaultSeriesSeriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_default': typeof DefaultRouteRouteWithChildren
  '/_external': typeof ExternalRouteRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteRouteWithChildren
  '/_videoPlayer': typeof VideoPlayerRouteRouteWithChildren
  '/download': typeof DownloadRoute
  '/_default/catalog': typeof DefaultCatalogRoute
  '/_default/contact-us': typeof DefaultContactUsRoute
  '/_default/dunning': typeof DefaultDunningRoute
  '/_default/faq': typeof DefaultFaqRoute
  '/_default/money-back-policy': typeof DefaultMoneyBackPolicyRoute
  '/_default/my-list': typeof DefaultMyListRoute
  '/_default/privacy': typeof DefaultPrivacyRoute
  '/_default/profile': typeof DefaultProfileRoute
  '/_default/refund': typeof DefaultRefundRoute
  '/_default/retention': typeof DefaultRetentionRoute
  '/_default/rewards-tab': typeof DefaultRewardsTabRoute
  '/_default/shop': typeof DefaultShopRoute
  '/_default/terms': typeof DefaultTermsRoute
  '/_default/winback': typeof DefaultWinbackRoute
  '/_external/get-app': typeof ExternalGetAppRoute
  '/_videoPlayer/series-details': typeof VideoPlayerSeriesDetailsRoute
  '/_default/': typeof DefaultIndexRoute
  '/_default/series/$series': typeof DefaultSeriesSeriesRouteRouteWithChildren
  '/_default/actors/$actor': typeof DefaultActorsActorRoute
  '/_default/categories/$category': typeof DefaultCategoriesCategoryRoute
  '/_default/themes/$theme': typeof DefaultThemesThemeRoute
  '/_unauthenticated/auth/link': typeof UnauthenticatedAuthLinkRoute
  '/_unauthenticated/auth/recover': typeof UnauthenticatedAuthRecoverRoute
  '/_videoPlayer/$series/$episode': typeof VideoPlayerSeriesEpisodeRoute
  '/_videoPlayer/series-player/{-$id}': typeof VideoPlayerSeriesPlayerChar123IdChar125Route
  '/_videoPlayer/seriesPlayer/$id': typeof VideoPlayerSeriesPlayerIdRoute
  '/_default/series/': typeof DefaultSeriesIndexRoute
  '/_videoPlayer/$series/': typeof VideoPlayerSeriesIndexRoute
  '/_default/series/$series/behind-the-scenes': typeof DefaultSeriesSeriesBehindTheScenesRoute
  '/_default/series/$series/cast': typeof DefaultSeriesSeriesCastRoute
  '/_default/series/$series/episodes': typeof DefaultSeriesSeriesEpisodesRoute
  '/_default/series/$series/recommendations': typeof DefaultSeriesSeriesRecommendationsRoute
  '/_default/series/$series/': typeof DefaultSeriesSeriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/download'
    | '/catalog'
    | '/contact-us'
    | '/dunning'
    | '/faq'
    | '/money-back-policy'
    | '/my-list'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/retention'
    | '/rewards-tab'
    | '/shop'
    | '/terms'
    | '/winback'
    | '/get-app'
    | '/series-details'
    | '/series/$series'
    | '/actors/$actor'
    | '/categories/$category'
    | '/themes/$theme'
    | '/auth/link'
    | '/auth/recover'
    | '/$series/$episode'
    | '/series-player/{-$id}'
    | '/seriesPlayer/$id'
    | '/series/'
    | '/$series/'
    | '/series/$series/behind-the-scenes'
    | '/series/$series/cast'
    | '/series/$series/episodes'
    | '/series/$series/recommendations'
    | '/series/$series/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/download'
    | '/catalog'
    | '/contact-us'
    | '/dunning'
    | '/faq'
    | '/money-back-policy'
    | '/my-list'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/retention'
    | '/rewards-tab'
    | '/shop'
    | '/terms'
    | '/winback'
    | '/get-app'
    | '/series-details'
    | '/actors/$actor'
    | '/categories/$category'
    | '/themes/$theme'
    | '/auth/link'
    | '/auth/recover'
    | '/$series/$episode'
    | '/series-player/{-$id}'
    | '/seriesPlayer/$id'
    | '/series'
    | '/$series'
    | '/series/$series/behind-the-scenes'
    | '/series/$series/cast'
    | '/series/$series/episodes'
    | '/series/$series/recommendations'
    | '/series/$series'
  id:
    | '__root__'
    | '/_default'
    | '/_external'
    | '/_unauthenticated'
    | '/_videoPlayer'
    | '/download'
    | '/_default/catalog'
    | '/_default/contact-us'
    | '/_default/dunning'
    | '/_default/faq'
    | '/_default/money-back-policy'
    | '/_default/my-list'
    | '/_default/privacy'
    | '/_default/profile'
    | '/_default/refund'
    | '/_default/retention'
    | '/_default/rewards-tab'
    | '/_default/shop'
    | '/_default/terms'
    | '/_default/winback'
    | '/_external/get-app'
    | '/_videoPlayer/series-details'
    | '/_default/'
    | '/_default/series/$series'
    | '/_default/actors/$actor'
    | '/_default/categories/$category'
    | '/_default/themes/$theme'
    | '/_unauthenticated/auth/link'
    | '/_unauthenticated/auth/recover'
    | '/_videoPlayer/$series/$episode'
    | '/_videoPlayer/series-player/{-$id}'
    | '/_videoPlayer/seriesPlayer/$id'
    | '/_default/series/'
    | '/_videoPlayer/$series/'
    | '/_default/series/$series/behind-the-scenes'
    | '/_default/series/$series/cast'
    | '/_default/series/$series/episodes'
    | '/_default/series/$series/recommendations'
    | '/_default/series/$series/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DefaultRouteRoute: typeof DefaultRouteRouteWithChildren
  ExternalRouteRoute: typeof ExternalRouteRouteWithChildren
  UnauthenticatedRouteRoute: typeof UnauthenticatedRouteRouteWithChildren
  VideoPlayerRouteRoute: typeof VideoPlayerRouteRouteWithChildren
  DownloadRoute: typeof DownloadRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_videoPlayer': {
      id: '/_videoPlayer'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof VideoPlayerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_external': {
      id: '/_external'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ExternalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_default': {
      id: '/_default'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DefaultRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_default/': {
      id: '/_default/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DefaultIndexRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_videoPlayer/series-details': {
      id: '/_videoPlayer/series-details'
      path: '/series-details'
      fullPath: '/series-details'
      preLoaderRoute: typeof VideoPlayerSeriesDetailsRouteImport
      parentRoute: typeof VideoPlayerRouteRoute
    }
    '/_external/get-app': {
      id: '/_external/get-app'
      path: '/get-app'
      fullPath: '/get-app'
      preLoaderRoute: typeof ExternalGetAppRouteImport
      parentRoute: typeof ExternalRouteRoute
    }
    '/_default/winback': {
      id: '/_default/winback'
      path: '/winback'
      fullPath: '/winback'
      preLoaderRoute: typeof DefaultWinbackRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/terms': {
      id: '/_default/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof DefaultTermsRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/shop': {
      id: '/_default/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof DefaultShopRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/rewards-tab': {
      id: '/_default/rewards-tab'
      path: '/rewards-tab'
      fullPath: '/rewards-tab'
      preLoaderRoute: typeof DefaultRewardsTabRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/retention': {
      id: '/_default/retention'
      path: '/retention'
      fullPath: '/retention'
      preLoaderRoute: typeof DefaultRetentionRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/refund': {
      id: '/_default/refund'
      path: '/refund'
      fullPath: '/refund'
      preLoaderRoute: typeof DefaultRefundRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/profile': {
      id: '/_default/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DefaultProfileRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/privacy': {
      id: '/_default/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof DefaultPrivacyRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/my-list': {
      id: '/_default/my-list'
      path: '/my-list'
      fullPath: '/my-list'
      preLoaderRoute: typeof DefaultMyListRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/money-back-policy': {
      id: '/_default/money-back-policy'
      path: '/money-back-policy'
      fullPath: '/money-back-policy'
      preLoaderRoute: typeof DefaultMoneyBackPolicyRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/faq': {
      id: '/_default/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof DefaultFaqRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/dunning': {
      id: '/_default/dunning'
      path: '/dunning'
      fullPath: '/dunning'
      preLoaderRoute: typeof DefaultDunningRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/contact-us': {
      id: '/_default/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof DefaultContactUsRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/catalog': {
      id: '/_default/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof DefaultCatalogRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_videoPlayer/$series/': {
      id: '/_videoPlayer/$series/'
      path: '/$series'
      fullPath: '/$series/'
      preLoaderRoute: typeof VideoPlayerSeriesIndexRouteImport
      parentRoute: typeof VideoPlayerRouteRoute
    }
    '/_default/series/': {
      id: '/_default/series/'
      path: '/series'
      fullPath: '/series/'
      preLoaderRoute: typeof DefaultSeriesIndexRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_videoPlayer/seriesPlayer/$id': {
      id: '/_videoPlayer/seriesPlayer/$id'
      path: '/seriesPlayer/$id'
      fullPath: '/seriesPlayer/$id'
      preLoaderRoute: typeof VideoPlayerSeriesPlayerIdRouteImport
      parentRoute: typeof VideoPlayerRouteRoute
    }
    '/_videoPlayer/series-player/{-$id}': {
      id: '/_videoPlayer/series-player/{-$id}'
      path: '/series-player/{-$id}'
      fullPath: '/series-player/{-$id}'
      preLoaderRoute: typeof VideoPlayerSeriesPlayerChar123IdChar125RouteImport
      parentRoute: typeof VideoPlayerRouteRoute
    }
    '/_videoPlayer/$series/$episode': {
      id: '/_videoPlayer/$series/$episode'
      path: '/$series/$episode'
      fullPath: '/$series/$episode'
      preLoaderRoute: typeof VideoPlayerSeriesEpisodeRouteImport
      parentRoute: typeof VideoPlayerRouteRoute
    }
    '/_unauthenticated/auth/recover': {
      id: '/_unauthenticated/auth/recover'
      path: '/auth/recover'
      fullPath: '/auth/recover'
      preLoaderRoute: typeof UnauthenticatedAuthRecoverRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/auth/link': {
      id: '/_unauthenticated/auth/link'
      path: '/auth/link'
      fullPath: '/auth/link'
      preLoaderRoute: typeof UnauthenticatedAuthLinkRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_default/themes/$theme': {
      id: '/_default/themes/$theme'
      path: '/themes/$theme'
      fullPath: '/themes/$theme'
      preLoaderRoute: typeof DefaultThemesThemeRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/categories/$category': {
      id: '/_default/categories/$category'
      path: '/categories/$category'
      fullPath: '/categories/$category'
      preLoaderRoute: typeof DefaultCategoriesCategoryRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/actors/$actor': {
      id: '/_default/actors/$actor'
      path: '/actors/$actor'
      fullPath: '/actors/$actor'
      preLoaderRoute: typeof DefaultActorsActorRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/series/$series': {
      id: '/_default/series/$series'
      path: '/series/$series'
      fullPath: '/series/$series'
      preLoaderRoute: typeof DefaultSeriesSeriesRouteRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/_default/series/$series/': {
      id: '/_default/series/$series/'
      path: '/'
      fullPath: '/series/$series/'
      preLoaderRoute: typeof DefaultSeriesSeriesIndexRouteImport
      parentRoute: typeof DefaultSeriesSeriesRouteRoute
    }
    '/_default/series/$series/recommendations': {
      id: '/_default/series/$series/recommendations'
      path: '/recommendations'
      fullPath: '/series/$series/recommendations'
      preLoaderRoute: typeof DefaultSeriesSeriesRecommendationsRouteImport
      parentRoute: typeof DefaultSeriesSeriesRouteRoute
    }
    '/_default/series/$series/episodes': {
      id: '/_default/series/$series/episodes'
      path: '/episodes'
      fullPath: '/series/$series/episodes'
      preLoaderRoute: typeof DefaultSeriesSeriesEpisodesRouteImport
      parentRoute: typeof DefaultSeriesSeriesRouteRoute
    }
    '/_default/series/$series/cast': {
      id: '/_default/series/$series/cast'
      path: '/cast'
      fullPath: '/series/$series/cast'
      preLoaderRoute: typeof DefaultSeriesSeriesCastRouteImport
      parentRoute: typeof DefaultSeriesSeriesRouteRoute
    }
    '/_default/series/$series/behind-the-scenes': {
      id: '/_default/series/$series/behind-the-scenes'
      path: '/behind-the-scenes'
      fullPath: '/series/$series/behind-the-scenes'
      preLoaderRoute: typeof DefaultSeriesSeriesBehindTheScenesRouteImport
      parentRoute: typeof DefaultSeriesSeriesRouteRoute
    }
  }
}

interface DefaultSeriesSeriesRouteRouteChildren {
  DefaultSeriesSeriesBehindTheScenesRoute: typeof DefaultSeriesSeriesBehindTheScenesRoute
  DefaultSeriesSeriesCastRoute: typeof DefaultSeriesSeriesCastRoute
  DefaultSeriesSeriesEpisodesRoute: typeof DefaultSeriesSeriesEpisodesRoute
  DefaultSeriesSeriesRecommendationsRoute: typeof DefaultSeriesSeriesRecommendationsRoute
  DefaultSeriesSeriesIndexRoute: typeof DefaultSeriesSeriesIndexRoute
}

const DefaultSeriesSeriesRouteRouteChildren: DefaultSeriesSeriesRouteRouteChildren =
  {
    DefaultSeriesSeriesBehindTheScenesRoute:
      DefaultSeriesSeriesBehindTheScenesRoute,
    DefaultSeriesSeriesCastRoute: DefaultSeriesSeriesCastRoute,
    DefaultSeriesSeriesEpisodesRoute: DefaultSeriesSeriesEpisodesRoute,
    DefaultSeriesSeriesRecommendationsRoute:
      DefaultSeriesSeriesRecommendationsRoute,
    DefaultSeriesSeriesIndexRoute: DefaultSeriesSeriesIndexRoute,
  }

const DefaultSeriesSeriesRouteRouteWithChildren =
  DefaultSeriesSeriesRouteRoute._addFileChildren(
    DefaultSeriesSeriesRouteRouteChildren,
  )

interface DefaultRouteRouteChildren {
  DefaultCatalogRoute: typeof DefaultCatalogRoute
  DefaultContactUsRoute: typeof DefaultContactUsRoute
  DefaultDunningRoute: typeof DefaultDunningRoute
  DefaultFaqRoute: typeof DefaultFaqRoute
  DefaultMoneyBackPolicyRoute: typeof DefaultMoneyBackPolicyRoute
  DefaultMyListRoute: typeof DefaultMyListRoute
  DefaultPrivacyRoute: typeof DefaultPrivacyRoute
  DefaultProfileRoute: typeof DefaultProfileRoute
  DefaultRefundRoute: typeof DefaultRefundRoute
  DefaultRetentionRoute: typeof DefaultRetentionRoute
  DefaultRewardsTabRoute: typeof DefaultRewardsTabRoute
  DefaultShopRoute: typeof DefaultShopRoute
  DefaultTermsRoute: typeof DefaultTermsRoute
  DefaultWinbackRoute: typeof DefaultWinbackRoute
  DefaultIndexRoute: typeof DefaultIndexRoute
  DefaultSeriesSeriesRouteRoute: typeof DefaultSeriesSeriesRouteRouteWithChildren
  DefaultActorsActorRoute: typeof DefaultActorsActorRoute
  DefaultCategoriesCategoryRoute: typeof DefaultCategoriesCategoryRoute
  DefaultThemesThemeRoute: typeof DefaultThemesThemeRoute
  DefaultSeriesIndexRoute: typeof DefaultSeriesIndexRoute
}

const DefaultRouteRouteChildren: DefaultRouteRouteChildren = {
  DefaultCatalogRoute: DefaultCatalogRoute,
  DefaultContactUsRoute: DefaultContactUsRoute,
  DefaultDunningRoute: DefaultDunningRoute,
  DefaultFaqRoute: DefaultFaqRoute,
  DefaultMoneyBackPolicyRoute: DefaultMoneyBackPolicyRoute,
  DefaultMyListRoute: DefaultMyListRoute,
  DefaultPrivacyRoute: DefaultPrivacyRoute,
  DefaultProfileRoute: DefaultProfileRoute,
  DefaultRefundRoute: DefaultRefundRoute,
  DefaultRetentionRoute: DefaultRetentionRoute,
  DefaultRewardsTabRoute: DefaultRewardsTabRoute,
  DefaultShopRoute: DefaultShopRoute,
  DefaultTermsRoute: DefaultTermsRoute,
  DefaultWinbackRoute: DefaultWinbackRoute,
  DefaultIndexRoute: DefaultIndexRoute,
  DefaultSeriesSeriesRouteRoute: DefaultSeriesSeriesRouteRouteWithChildren,
  DefaultActorsActorRoute: DefaultActorsActorRoute,
  DefaultCategoriesCategoryRoute: DefaultCategoriesCategoryRoute,
  DefaultThemesThemeRoute: DefaultThemesThemeRoute,
  DefaultSeriesIndexRoute: DefaultSeriesIndexRoute,
}

const DefaultRouteRouteWithChildren = DefaultRouteRoute._addFileChildren(
  DefaultRouteRouteChildren,
)

interface ExternalRouteRouteChildren {
  ExternalGetAppRoute: typeof ExternalGetAppRoute
}

const ExternalRouteRouteChildren: ExternalRouteRouteChildren = {
  ExternalGetAppRoute: ExternalGetAppRoute,
}

const ExternalRouteRouteWithChildren = ExternalRouteRoute._addFileChildren(
  ExternalRouteRouteChildren,
)

interface UnauthenticatedRouteRouteChildren {
  UnauthenticatedAuthLinkRoute: typeof UnauthenticatedAuthLinkRoute
  UnauthenticatedAuthRecoverRoute: typeof UnauthenticatedAuthRecoverRoute
}

const UnauthenticatedRouteRouteChildren: UnauthenticatedRouteRouteChildren = {
  UnauthenticatedAuthLinkRoute: UnauthenticatedAuthLinkRoute,
  UnauthenticatedAuthRecoverRoute: UnauthenticatedAuthRecoverRoute,
}

const UnauthenticatedRouteRouteWithChildren =
  UnauthenticatedRouteRoute._addFileChildren(UnauthenticatedRouteRouteChildren)

interface VideoPlayerRouteRouteChildren {
  VideoPlayerSeriesDetailsRoute: typeof VideoPlayerSeriesDetailsRoute
  VideoPlayerSeriesEpisodeRoute: typeof VideoPlayerSeriesEpisodeRoute
  VideoPlayerSeriesPlayerChar123IdChar125Route: typeof VideoPlayerSeriesPlayerChar123IdChar125Route
  VideoPlayerSeriesPlayerIdRoute: typeof VideoPlayerSeriesPlayerIdRoute
  VideoPlayerSeriesIndexRoute: typeof VideoPlayerSeriesIndexRoute
}

const VideoPlayerRouteRouteChildren: VideoPlayerRouteRouteChildren = {
  VideoPlayerSeriesDetailsRoute: VideoPlayerSeriesDetailsRoute,
  VideoPlayerSeriesEpisodeRoute: VideoPlayerSeriesEpisodeRoute,
  VideoPlayerSeriesPlayerChar123IdChar125Route:
    VideoPlayerSeriesPlayerChar123IdChar125Route,
  VideoPlayerSeriesPlayerIdRoute: VideoPlayerSeriesPlayerIdRoute,
  VideoPlayerSeriesIndexRoute: VideoPlayerSeriesIndexRoute,
}

const VideoPlayerRouteRouteWithChildren =
  VideoPlayerRouteRoute._addFileChildren(VideoPlayerRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DefaultRouteRoute: DefaultRouteRouteWithChildren,
  ExternalRouteRoute: ExternalRouteRouteWithChildren,
  UnauthenticatedRouteRoute: UnauthenticatedRouteRouteWithChildren,
  VideoPlayerRouteRoute: VideoPlayerRouteRouteWithChildren,
  DownloadRoute: DownloadRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
